import { render, staticRenderFns } from "./ClientUsers.vue?vue&type=template&id=ed9b2076"
import script from "./ClientUsers.vue?vue&type=script&lang=js"
export * from "./ClientUsers.vue?vue&type=script&lang=js"
import style0 from "./ClientUsers.vue?vue&type=style&index=0&id=ed9b2076&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports